var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 27.1562C31.0938 28.0938 31.0938 29.5 30.25 30.3438C29.3125 31.2812 27.9062 31.2812 27.0625 30.3438L16 19.1875L4.84375 30.3438C3.90625 31.2812 2.5 31.2812 1.65625 30.3438C0.71875 29.5 0.71875 28.0938 1.65625 27.1562L12.8125 16L1.65625 4.84375C0.71875 3.90625 0.71875 2.5 1.65625 1.65625C2.5 0.71875 3.90625 0.71875 4.75 1.65625L16 12.9062L27.1562 1.75C28 0.8125 29.4062 0.8125 30.25 1.75C31.1875 2.59375 31.1875 4 30.25 4.9375L19.0938 16L30.25 27.1562Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconDesktop);
export default __webpack_public_path__ + "static/media/closeIconDesktop.7cdff45816f8f0abbe916e8ad0e21cb4.svg";
export { ForwardRef as ReactComponent };